import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/Button';
import { IconCheck, IconCopy, IconShare } from '../../components/Icon';
import InputText from '../../components/InputText';
import Modal from '../../components/Modal';
import { Text } from '../../components/Text';
import { InputWrapper } from './wrapper';

const ShareButton = () => {
  const { t } = useTranslation(['common', 'other']);
  const [shareModal, setShareModal] = useState(false);
  const [valueCopied, setValueCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onClick = () => {
    if (navigator.share) {
      navigator.share({
        url: window.location.href,
      });
    } else {
      setShareModal(true);
    }
  };

  const onCopyToClipboard = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand('copy');
      setValueCopied(true);
    }
  };

  const onCloseModal = () => {
    setShareModal(false);
    setValueCopied(false);
  };

  return (
    <>
      <Button
        $shadow
        $fullWidth
        $size="small"
        onClick={onClick}
        title={t('Share', { ns: 'common' })}
      >
        <Text $tone="secondary">
          <IconShare $size="20px" />
        </Text>
        {t('Share', { ns: 'common' })}
      </Button>
      {shareModal && (
        <Modal heading={t('copyLink', { ns: 'other' })} onClose={onCloseModal}>
          <InputWrapper>
            <InputText
              readOnly
              value={window.location.href}
              ref={inputRef}
              aria-label={t('linkToShare', { ns: 'other' })}
            />
            <Button
              $shadow
              $size="small"
              onClick={onCopyToClipboard}
              title={t('copyLink', { ns: 'other' })}
            >
              {valueCopied ? (
                <>
                  <Text $tone="secondary" aria-hidden="true">
                    <IconCheck $size="20px" />
                  </Text>
                  {t('copied', { ns: 'other' })}
                </>
              ) : (
                <>
                  <Text $tone="secondary" aria-hidden="true">
                    <IconCopy $size="20px" />
                  </Text>
                  {t('copy', { ns: 'other' })}
                </>
              )}
            </Button>
          </InputWrapper>
        </Modal>
      )}
    </>
  );
};

export default ShareButton;
